import React from 'react';
import { withTranslation } from 'react-i18next';
import { Form } from 'react-final-form';
import { ButtonToolbar, Button, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import CourseTab from './CourseTab';
import validate from './Validate';
import NavigationTabs from './NavigationTabs';
import CurriculumTab from './CurriculumTab';
import ObjectivesTab from './ObjectivesTab';
import { ACTIVE_TAB } from '../../../shared/utils/constants';

const CourseForm = (props) => {
  const {
    t,
    dispatch,
    backHandler,
    saveForm,
    dto,
    employees,
    step,
    turnBackStep,
    nextStep,
    removeCourseStep,
    activeClassesByCourse,
  } = props;

  return (
    <Form
      initialValues={{ ...dto }}
      onSubmit={saveForm}
      validate={validate}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Col md={12} lg={12} xl={12}>
            <NavigationTabs step={step} nextStep={nextStep} dto={dto}>
              <CourseTab
                title={t('general.course')}
                dto={dto}
                employees={employees}
                removeCourseStep={removeCourseStep}
              />
              <CurriculumTab
                title={t('general.curriculum')}
                dispatch={dispatch}
                steps={dto.steps}
                curriculum={dto.curriculum}
                activeClassesByCourse={activeClassesByCourse}
              />
              <ObjectivesTab
                title={t('general.objectives')}
                curriculum={dto.curriculum}
                objectives={dto.objectives}
              />
            </NavigationTabs>
            <ButtonToolbar className="form__button-toolbar">
              <Button
                color="primary"
                onClick={step === ACTIVE_TAB.ONE ? backHandler : turnBackStep}
              >
                {step === ACTIVE_TAB.ONE
                  ? t('general.back')
                  : t('general.turn-back')}
              </Button>
              <Button color="success" type="submit">
                {step === ACTIVE_TAB.THREE
                  ? t('general.save')
                  : t('general.save-advance')}
              </Button>
            </ButtonToolbar>
          </Col>
        </form>
      )}
    />
  );
};

CourseForm.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  saveForm: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  employees: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  step: PropTypes.string.isRequired,
  turnBackStep: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  removeCourseStep: PropTypes.func.isRequired,
  activeClassesByCourse: PropTypes.number.isRequired,
};

export default withTranslation('common')(CourseForm);
